import * as React from "react";
interface SVGProps {
  height?: number | string;
  width?: number | string;
  color?: string;
}

const SvgArrowRightBold = (props: SVGProps) => {
  return (
    <svg width="23" height="26" viewBox="0 0 23 26" fill="none" {...props}>
      <path
        d="M13.0508 22.2812L11.5391 20.7812L14.2227 18.0859C15.125 17.207 16.1211 16.2578 17.082 15.3906C16.3672 15.4258 15.6289 15.4492 14.9258 15.4492H3.44141V13.2695H14.9258C15.6289 13.2695 16.3672 13.293 17.0703 13.3281C16.1211 12.4609 15.125 11.5234 14.2227 10.6328L11.5273 7.94922L13.0508 6.4375L20.9727 14.3594L13.0508 22.2812Z"
        fill={props.color || "#FF5900"}
      />
    </svg>
  );
};

export default SvgArrowRightBold;
